<template>
  <div class="backgroud-white cs-appointment-success">
    <div class="backgroud-gray-popup popup-content-area cs-courseSchedule-content">
      <el-row class="cs-appointment-header-icon">
        <el-col>
          <img src="../../assets/success.png" />
        </el-col>
      </el-row>
      <el-row class="cs-appointment-header-title">
        <el-col>
          <span class="el-dialog__title">预约成功</span>
        </el-col>
      </el-row>
      <el-row class="cs-appointment-success-info">
        <el-col>
          <span v-if="dataIn.isApprove">预约成功，等待管理员审核。审核通过后，即可按照预约时间正常观看视频。<br/><br/>
            观看视频时，请务必<strong class="cs-appointment-success-import">准时出席</strong>
            <!-- ，观看结束后押金将自动退还。<br/>
            为防止速成学员共享视频，观看视频时请务必携带一张<strong class="cs-appointment-success-import">Photo ID</strong>，以便前台随机抽查。<br/><br/>
            您可以在预约时间<strong class="cs-appointment-success-import">24</strong>小时前修改该预约。<br/>
            您可以在预约时间<strong class="cs-appointment-success-import">3</strong>小时前取消该预约。<br/>
            如在预约时间24小时前取消该预约，系统退还所有费用，<br/>
            如在预约时间24小时内取消该预约，系统仅退还<strong class="cs-appointment-success-import">50%</strong>费用，<br/>
            在预约时间3小时以内无法取消该预约。 -->
          </span>
          <span v-if="!dataIn.isApprove">
            请务必<strong class="cs-appointment-success-import">准时出席</strong>
            <!-- ，观看结束后押金将自动退还。<br/>
            为防止速成学员共享视频，观看视频时请务必携带一张<strong class="cs-appointment-success-import">Photo ID</strong>，以便前台随机抽查。<br/><br/>
            您可以在预约时间<strong class="cs-appointment-success-import">24</strong>小时前修改该预约。<br/>
            您可以在预约时间<strong class="cs-appointment-success-import">3</strong>小时前取消该预约。<br/>
            如在预约时间24小时前取消该预约，系统退还所有费用，<br/>
            如在预约时间24小时内取消该预约，系统仅退还<strong class="cs-appointment-success-import">50%</strong>费用，<br/>
            在预约时间3小时以内无法取消该预约。 -->
          </span>

        </el-col>
      </el-row>
      <el-row class="cs-appointment-success-content">
        <el-col :span="12">
          <el-form label-width="100px">
            <el-form-item label="日期:">
              <span>{{dataIn.date}}</span>
            </el-form-item>
            <el-form-item label="校区:">
              <span>{{dataIn.campusName}}</span>
            </el-form-item>
            <el-form-item label="预约课程:">
              <span>{{dataIn.courseName}}</span>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form label-width="100px">
            <el-form-item label="预约时间:">
              <span>{{dataIn.startTime}} - {{dataIn.endTime}}</span>
            </el-form-item>
            <el-form-item label="电脑:">
              <span>{{dataIn.computerName}}</span>
            </el-form-item>
            <el-form-item label="课程周:">
              <span>{{dataIn.weekText}}</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <div v-if="dataIn.isApprove" class="cs-appointment-success-application">
        <el-row>
          <el-col :span="4">
            <span>特殊申请：</span>
          </el-col>
          <el-col :span="20">
            <div>
              <span>{{dataIn.applicationDescription}}</span>
            </div>
            <div
              v-for="(file, index) in dataIn.fileList"
              :key="index"
            >
              <span class="cs-appointment-success-fileName">{{file.FileName}}</span>
              上传于
              <span>{{file.DateText}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col :span="24">
          <el-button
            type="primary"
            @click="onConfirm"
          >确认</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-appointment-success {
  .cs-appointment-header-icon {
    text-align: center;
    img {
      height: 80px;
    }
  }
  .cs-appointment-header-title {
    text-align: center;
    margin: 1rem 0;
  }

  .cs-appointment-success-info {
    text-align: center;
    color: #568199;
    background-color: #f9fbfd;
    margin-bottom: 1rem;

    span {
      display: block;
      padding: 1rem 0;
    }
  }

  .cs-appointment-success-content{
    padding: 1rem;
  }

  .cs-appointment-success-fileName {
    color: #59c2e6;
  }

  .cs-appointment-success-application{
    margin-top: 1rem;
    padding-top: 1rem;
    padding-left: 1rem;
    border-top: 1px solid #dbdbdb;
  }

  .popup-footer {
    padding: 0 50px;
    margin-right: 0;

    text-align: center;
  }
  .cs-appointment-success-import {
    font-weight:bold;
    font-size:1.2em;
    color:red;
  }
}
.el-form-item {
  margin-bottom: 0px;
}
</style>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  created() {},
  props: {
    dataIn: {
      date: String,
      startTime: String,
      endTime: String,
      campusName: String,
      computerName: String,
      courseName: String,
      weekText: String,
      isApprove: Boolean,
      applicationDescription: String,
      fileList: Array
    }
  },
  methods: {
    onConfirm() {
      this.$emit("close");
    }
  },
  watch: {
    dataIn: function() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/avappSuccess.vue